import type {ContentType} from '@deezer/next/services/types/contentType';

export default {
	ajax: '/analytic/ajax',
	view: '/analytic/view',
	contentData: (type: ContentType, id: string) => `/analytic/${type}/${id}`,

	topArtists: '/top-artists',
	topTracks: '/top-tracks',
	timeseries: '/timeseries',
	contexts: '/contexts',
	trendingArtists: '/trending-artists',
	trendingTracks: '/trending-tracks',
};
